module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity4.2bc50b71.jpg";